/**
 * Конфигурация фильтров поиска и характеристик карточки товара
 * по типу номенклатуры (шины / диски / АКБ / масла).
 */

export const FILTER_CONFIG = {
  tire: {
    keywords: ['шин', 'tire', 'tyre', 'покрышк'],
  },
  wheel: { keywords: ['диск', 'disk', 'wheel', 'колёс', 'литы', 'штамп', 'кован'] },
  battery: { keywords: ['аккумулятор', 'акб', 'battery', 'батаре'] },
  oil: { keywords: ['масл', 'oil', 'смазк'] },
};

export const PRODUCT_SPECS_CONFIG = {
  tire: [
    { key: 'manufacturer', label: 'Производитель' },
    { key: '_size', label: 'Размер', format: 'tire_size' },
    { key: 'tire_spec.season', label: 'Сезон', format: 'season' },
    { key: 'tire_spec.width', label: 'Ширина' },
    { key: 'tire_spec.profile', label: 'Профиль' },
    { key: 'tire_spec.diameter', label: 'Диаметр' },
    { key: 'tire_spec.studded', label: 'Шипы', format: 'boolean' },
    { key: 'tire_spec.load_index', label: 'Индекс нагрузки' },
    { key: 'tire_spec.speed_index', label: 'Индекс скорости' },
  ],
  wheel: [
    { key: 'manufacturer', label: 'Производитель' },
    { key: 'wheel_spec.diameter', label: 'Диаметр', suffix: '"' },
    { key: 'wheel_spec.width', label: 'Ширина' },
    { key: 'wheel_spec.et', label: 'Вылет (ET)' },
    { key: 'wheel_spec.pcd', label: 'PCD' },
    { key: 'wheel_spec.dia', label: 'DIA' },
    { key: 'wheel_spec.bolts', label: 'Болтов' },
    { key: 'wheel_spec.wheel_type', label: 'Тип' },
    { key: 'wheel_spec.color', label: 'Цвет' },
  ],
  battery: [
    { key: 'manufacturer', label: 'Производитель' },
    { key: 'battery_spec.capacity', label: 'Ёмкость', suffix: ' Ah' },
    { key: 'battery_spec.voltage', label: 'Напряжение', suffix: ' V' },
    { key: 'battery_spec.cca', label: 'Пусковой ток', suffix: ' A' },
    { key: 'battery_spec.polarity', label: 'Полярность' },
    { key: 'battery_spec.dimensions', label: 'Размеры' },
  ],
  oil: [
    { key: 'manufacturer', label: 'Производитель' },
    { key: 'oil_spec.viscosity', label: 'Вязкость' },
    { key: 'oil_spec.oil_type', label: 'Тип' },
    { key: 'oil_spec.volume', label: 'Объём', suffix: ' л' },
    { key: 'oil_spec.specification', label: 'Спецификация' },
  ],
  default: [
    { key: 'manufacturer', label: 'Производитель' },
    { key: 'type', label: 'Тип' },
  ],
};

export const TIRE_WIDTHS = [
  30, 31, 32, 33, 35, 37, 135, 145, 155, 165, 175, 185, 195, 205, 215, 225, 235, 245, 255, 265, 275, 285,
  295, 305, 315, 325, 335, 345, 355,
];
export const TIRE_PROFILES = [9.5, 10.5, 11.5, 12.5, 13.5, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85];
export const TIRE_DIAMETERS = [12, 13, 14, 15, 16, 17, 17.5, 18, 19, 19.5, 20, 21, 22, 22.5, 23, 24];

export function detectProductType(categoryCode = '', categoryTitle = '') {
  const searchText = `${categoryCode} ${categoryTitle}`.toLowerCase();
  for (const [type, config] of Object.entries(FILTER_CONFIG)) {
    if (config.keywords.some((kw) => searchText.includes(kw))) return type;
  }
  return 'tire';
}

export function getNestedValue(obj, path) {
  if (path.startsWith('attributes.')) {
    const specPath = path.replace('attributes.', 'specs.');
    const specValue = specPath.split('.').reduce((o, k) => o?.[k], obj);
    if (specValue !== undefined && specValue !== null) return specValue;
    const attrValue = path.split('.').reduce((o, k) => o?.[k], obj);
    return attrValue ?? null;
  }
  return path.split('.').reduce((o, k) => o?.[k], obj);
}
